import PropTypes from 'prop-types';
import React from 'react';
import MultiOpenQuestion from '../open/MultiOpenQuestion';
import MatrixOpenQuestion from '../open/MatrixOpenQuestion';
import DiscussionQuestion from '../discussion/DiscussionQuestion';
import ConstantSumQuestion from '../constantsum/ConstantSumQuestion';
import PasswordQuestion from '../password/PasswordQuestion';
import FillInTheBlankQuestion from '../fillintheblank/FillInTheBlankQuestion';
import RatingQuestion from '../rating/RatingQuestion';
import MatrixRatingQuestion from '../rating/MatrixRatingQuestion';
import SelectListQuestion from '../selector/SelectListQuestion';
import MatrixDropdownQuestion from '../selector/MatrixDropdownQuestion';
import MatrixSliderQuestion from '../selector/MatrixSliderQuestion';
import MatrixButtonsQuestion from '../selector/MatrixButtonsQuestion';
import MultiPartQuestion from '../multipart/MultiPartQuestion';
import NotificationQuestion from '../notification/NotificationQuestion';
import HeatMapQuestion from '../heatmap/HeatMapQuestion';
import TimedQuestion from '../timed/TimedQuestion';
import EmbeddedDecipherQuestion from '../embedded_decipher/EmbeddedDecipherQuestion';

const SurveyQuestion = props => {
  if (props._type === 'Survey::Notification') {
    return <NotificationQuestion {...props} />;
  }
  if (
    props._type === 'Survey::HeatMap' ||
    props._type === 'Survey::TimedHeatMap' ||
    props._type === 'Survey::StickyNote'
  ) {
    return <HeatMapQuestion {...props} />;
  }

  if (props._type === 'Survey::Timed') {
    return <TimedQuestion {...props} />;
  }
  if (props._type === 'Survey::Rating' && props.matrix) {
    return <MatrixRatingQuestion {...props} />;
  }
  if (props._type === 'Survey::Rating') {
    return <RatingQuestion {...props} />;
  }
  if (props._type === 'Survey::ConstantSum') {
    return <ConstantSumQuestion {...props} />;
  }
  if (props._type === 'Survey::Password') {
    return <PasswordQuestion {...props} />;
  }
  if (props._type === 'Survey::FillInTheBlank') {
    return <FillInTheBlankQuestion {...props} />;
  }
  if (props._type === 'Survey::Discussion') {
    return <DiscussionQuestion {...props} />;
  }
  if (props._type === 'Survey::MultiPart') {
    return <MultiPartQuestion {...props} />;
  }
  if (props._type === 'Survey::Open' && !props.matrix) {
    return <MultiOpenQuestion {...props} />;
  }
  if (props._type === 'Survey::Open' && props.matrix) {
    return <MatrixOpenQuestion {...props} />;
  }
  if (props._type === 'Survey::EmbeddedDecipher') {
    return <EmbeddedDecipherQuestion {...props} />;
  }
  if (
    !props.matrix &&
    (props._type === 'Survey::SingleSelect' ||
      props._type === 'Survey::MultipleSelect')
  ) {
    // Single or Multiselect, non matrix
    return <SelectListQuestion {...props} />;
  }
  if (
    props.matrix &&
    (props._type === 'Survey::SingleSelect' ||
      props._type === 'Survey::MultipleSelect') &&
    (props.presentation !== 'select' && props.presentation !== 'slider')
  ) {
    return <MatrixButtonsQuestion {...props} />;
  }
  if (
    props.matrix &&
    (props._type === 'Survey::SingleSelect' ||
      props._type === 'Survey::MultipleSelect') &&
    props.presentation === 'select'
  ) {
    return <MatrixDropdownQuestion {...props} />;
  }
  if (
    props.matrix &&
    (props._type === 'Survey::SingleSelect') &&
    props.presentation === 'slider'
  ) {
    return <MatrixSliderQuestion {...props} />;
  }

  return <MultiOpenQuestion {...props} />;
};

SurveyQuestion.displayName = 'SurveyQuestion';

SurveyQuestion.propTypes = {
  _type: PropTypes.string.isRequired,
  matrix: PropTypes.bool,
  bipolar: PropTypes.bool,
  number_of_fields: PropTypes.number,
  presentation: PropTypes.string,
  temp_response_attachment_keys: PropTypes.array
};

export default SurveyQuestion;
